module.exports = __webpack_public_path__ + "static/media/enabledHorizontalEventIcon.0f673f44.svg";